import { render, staticRenderFns } from "./TunItem.vue?vue&type=template&id=3188bb3e&scoped=true&"
import script from "./TunItem.vue?vue&type=script&lang=js&"
export * from "./TunItem.vue?vue&type=script&lang=js&"
import style0 from "./TunItem.vue?vue&type=style&index=0&id=3188bb3e&prod&lang=less&scoped=true&"
import style1 from "./TunItem.vue?vue&type=style&index=1&id=3188bb3e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3188bb3e",
  null
  
)

export default component.exports